module.exports = __webpack_public_path__ + "static/media/aus@3x.607832a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/flags/aus@3x.png
// module id = 90
// module chunks = 0